import Model from '@/store/plugins/orm/Model'
import { Product, ProductCategory } from './ModelRepository'

export class Button extends Model {
    static get entity () {
        return 'buttons'
    }

    static fields () {
        return {
            id: this.attr(null),
            background_color: this.attr(null),
            type: this.attr(null),
            category_id: this.attr(null),
            product_id: this.attr(null),
            row_num: this.attr(null),
            column_num: this.attr(null),
            image: this.attr(null),
            image_url: this.attr(null),
            image_fit: this.attr(0),
            image_halign: this.attr('center'),
            image_stretch: this.attr(1),
            image_valign: this.attr('center'),
            text: this.attr(null),
            text_halign: this.attr('center'),
            text_size: this.attr('12px'),
            text_valign: this.attr('center'),
            
            category: this.belongsTo(ProductCategory, 'category_id'),
            product: this.belongsTo(Product, 'product_id'),
        }
    }
}

export default Button
